import React, {useState, useEffect} from 'react'

import {apiAgent} from './axiosConfig';
import {Button} from './components/cta_utils/AnButton.js'

import {AnInputBox, AnSuggestionBox} from './components/input_utils/AnInput.js'

import LogoutHeader from './components/headers/logoutHeader.js'
import TryAlmaFree from './components/logout_components/tryAlmaFree.js'

import {updateCurrentUser} from './redux/currentUserSlice.js'
import { useDispatch, useSelector } from 'react-redux'
import {BrowserRouter, Route, Switch} from "react-router-dom";
import SignupScreen from './signupScreen';
import { Link } from 'react-router-dom';
import AnPasswordBox, { validatePassword } from './components/input_utils/AnPasswordBox.jsx';
import OtpVerification from './PreAuthRender/verification/OtpVerification.js';
import { AnInputCheckBox } from './components/input_utils/AnInputCheckBox.js';
import { FlashMessages } from './components/cta_utils/FlashMessages.js';
import OktaLoginScreen from './PreAuthRender/okta/OktaLoginScreen.jsx';
import { iss_sso_domain } from './components/utils/helper_utils.js';

class LoginScreen extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      email: '',
      password: '',
      isLoading: false,
      two_fa_enabled: false,
      errors: {},
      remember_me: false,
      successMessages: {}
    };
  }

  onSignupSucess = (response) => {
    this.props.onLoginSuccess(response);
  }

  onEmailInput = (event) => {
    this.setState({
      email: event.target.value,
      errors: {...this.state.errors, email: ""}
    })
  }

  onPasswordInput = (event) => {
    this.setState({
      password: event.target.value,
      errors: {...this.state.errors, password: ""}
    })
  }
  onFormSubmit = () => {
    var errors = {}, error = false;
    if(!this.state.email) { 
      errors["email"] = "No account found for this email\n";
      error = true;
    }
    if(!this.state.password) {
      errors["password"] = "Please enter Password.";
      error = true;
    }
    if(iss_sso_domain(this.state.email)){ 
      errors["button"] = "Your account only supports SSO login. Redirecting you...";
      error = true;
      setTimeout(() => window.location.href="/okta-login", 5000)            
    }
    this.setState({...this.state, errors: errors});
    if(error)
      return;
    this.setState({...this.state, isLoading: true});
    apiAgent({
      method: 'post',
      url: '/users/login',
      data: {
        email: this.state.email.toLowerCase(),
        password: this.state.password,
        remember_me: this.state.remember_me
      }
    }).then(
      (response) => {
        if(response.data.two_fa_enabled){
          this.setState({two_fa_enabled: response.data.two_fa_enabled})
        }
        else
          this.props.onLoginSuccess(response.data);
      },
      (error)  => {
        this.isLoading = false;
        let serverErrors = error.response.data.server_message
        let otp_limit_error = serverErrors?.otp_attemps_exceed || serverErrors?.wrong_otp_attemps_exceed
        if(error.response.data)
          this.setState({...this.state, isLoading: false, errors: {"password": error.response.data?.error || serverErrors?.password_error}});
        if(otp_limit_error)
        this.setState({...this.state, isLoading: false, successMessages: {
          messageTheme: 'warning',
          message: otp_limit_error,
          duration: 3000,
        }})
      }
    );
  }

  render(){
    return (
        <React.Fragment>.
          {this.state.two_fa_enabled ? <OtpVerification user_info={{email: this.state.email.toLowerCase()}} onLoginSuccess={this.props.onLoginSuccess}></OtpVerification> :
          (<div className="login_component_container">
            <div className="text_title_big" style={{textAlign: 'center'}}>
              Log in to your account
            </div>
            <div style={{marginTop: '24px'}}>
              <AnInputBox label={"Email"} error={this.state.errors["email"]}>
                <input type="text" id="email" value={this.state.email} onChange={this.onEmailInput} placeholder="johndoe@domain.com"/>
              </AnInputBox>
            </div>
            <div style={{marginTop: '8px'}}>
              <AnInputBox label="Password" error={this.state.errors["password"]}>
                <AnPasswordBox password={this.state.password} onChange={this.onPasswordInput} placeholder="password" tooltipEnable={false}></AnPasswordBox>
              </AnInputBox>
            </div>
            <Link to="/forgot_password" className='text_link hover_under_line' >
              Forgot password?
            </Link>
            <div className='btn_login'>
              <Button buttonSize="Big" onClick={this.onFormSubmit} error={this.state.errors?.button} disabled={this.state.errors?.button} isLoading={this.state.isLoading} buttonStyle={{width: '100%'}}>
                Log in
              </Button>
            </div>            
            <AnInputCheckBox
                label="Remember me for 30 days"
                isChecked={this.state.remember_me}
                style={{ marginTop: 8 }}

            >
                <input
                    type="checkbox"
                    checked={this.state.remember_me}
                    onChange={() => this.setState({remember_me: !this.state.remember_me })}>
                </input>
            </AnInputCheckBox>
            <div className="text_body_light" style={{marginTop: '16px', textAlign: 'center'}}>
              Don’t have an account?  <a href="/signup" className="text_link hover_under_line">Sign up</a>
            </div>
            {
            this.state.successMessages.message && (
            <FlashMessages 
              messageTheme={this.state.successMessages.messageTheme} 
              duration={this.state.successMessages.duration} 
              closeCallback={() =>
              this.setState({ successMessages: {
                message: "",
                duration: 0,
                from: ""} 
              })}
            >
              {this.state.successMessages.message}
            </FlashMessages>)
          }
          </div>
        )}
        </React.Fragment>
    );
  }
}

export default LoginScreen;
